import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import Button from 'components/V2/Button';
import PropTypes from 'prop-types';

import styles from './dropdownSelect.module.css';

import { ReactComponent as ChevronDown } from 'asset/IconsPack/at_chevron-down-filled.svg';
import { ReactComponent as ChevronUp } from 'asset/IconsPack/at_chevron-up.svg';

const DropdownIcon = ({ open }) =>
    open ? (
        <ChevronUp className={styles.dropdownIcon} />
    ) : (
        <ChevronDown className={styles.dropdownIcon} />
    );

DropdownIcon.propTypes = { open: PropTypes.bool };

function DropdownTrigger({ id, open, onClick, className, value, renderTrigger }) {
    return (
        <Button
            intent="secondary"
            size="md"
            onClick={onClick}
            className={clsx(styles.dropdownBtn, className)}
            id={id}
            aria-controls={open ? id : undefined}
            aria-expanded={open ? 'true' : undefined}
        >
            <Box className={styles.value_container}>
                {renderTrigger ? (
                    renderTrigger(value)
                ) : (
                    <Typography className={styles.value}>{value}</Typography>
                )}
            </Box>
            <DropdownIcon open={open} />
        </Button>
    );
}

DropdownTrigger.propTypes = {
    id: PropTypes.string,
    open: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    value: PropTypes.any,
    renderTrigger: PropTypes.func,
};

export default DropdownTrigger;
